import type { LngLatEle } from './geo'

export type Sport = 'hike' | 'bike' | 'mtb' | 'road' | 'gravel' | 'run'
export type TourKind = 'planned' | 'recorded' | 'completed'

export const SPORTS: { id: Sport; label: string; icon: string }[] = [
  { id: 'hike', label: 'Hiking', icon: '🥾' },
  { id: 'bike', label: 'Bike Touring', icon: '🚲' },
  { id: 'mtb', label: 'Mountain Biking', icon: '🚵' },
  { id: 'road', label: 'Road Cycling', icon: '🚴' },
  { id: 'gravel', label: 'Gravel Riding', icon: '🛤️' },
  { id: 'run', label: 'Running', icon: '🏃' },
]

export interface TourStats {
  distanceM: number
  ascentM: number
  descentM: number
  /** estimated duration for planned tours, elapsed for recorded */
  durationS: number
  movingTimeS?: number
  maxEleM?: number
  minEleM?: number
}

export interface Instruction {
  text: string
  /** distance from route start where the instruction applies, meters */
  atM: number
  /** maneuver hint used to pick an arrow icon */
  sign: number
}

/** A classified stretch of the route (surface or way type). */
export interface Segment {
  kind: string
  fromM: number
  toM: number
}

export interface Waypoint {
  lng: number
  lat: number
  name?: string
}

export interface TourData {
  coords: LngLatEle[]
  /** epoch ms per point, recorded tours only */
  times?: number[]
  /** point indices after which a GPS gap occurred */
  gaps?: number[]
  waypoints?: Waypoint[]
  stats: TourStats
  instructions?: Instruction[]
  surfaces?: Segment[]
  waytypes?: Segment[]
  notes?: string
}

export interface Tour {
  id: string
  name: string
  sport: Sport
  kind: TourKind
  data: TourData
  createdAt: number
  updatedAt: number
  deleted?: boolean
  /** true when the server has this exact revision */
  synced?: boolean
}
